import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactPixel from 'react-facebook-pixel';
function FacebookPixel() {
  const location = useLocation();
  useEffect(() => {
    ReactPixel.pageView();
  }, [location]);
  return <></>;
}
export default FacebookPixel;
